import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/mfa/user.mfa.query.gql"
import type {
  UserMfaQuery,
  UserMfaQueryVariables,
} from "@/v2-backoffice-client/user/mfa/__types__/user.mfa.query"

type Options = QueryHookOptions<UserMfaQuery, UserMfaQueryVariables>

export function useUserMfaQuery(options?: Options) {
  return useQuery<UserMfaQuery, UserMfaQueryVariables>(query, options)
}
